import { SVGProps, Ref, forwardRef } from 'react';

export const ArrowUpOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m2 7 .99.99L7.3 3.68V15h1.4V3.68l4.31 4.31L14 7 8 1z"
                fill="currentColor"
            />
        </g>
    </svg>
));
ArrowUpOutlinedSize16Glyph.displayName = 'ArrowUpOutlinedSize16Glyph';
